import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Fade from '@material-ui/core/Fade';
import FormHelperText from '@material-ui/core/FormHelperText';

// this is how we override the US-centric date formatting at the top of the month calendar.
class LocalizedUtils extends MomentUtils {
  getDatePickerHeaderText(date) {
    return date.format('D MMMM', { locale: this.locale });
  }
}

const useStyles = makeStyles({
  container: {
  },
  control: {
    marginTop: '1rem',
    marginBottom: '1rem',
  }
});

const MatchingFeesForm = ({values, errors, onChange}) => {
  const classes = useStyles();

  const setValue = (fieldName, value) => {
    onChange({...values, [fieldName]: value});
  };

  return (
    <MuiPickersUtilsProvider utils={LocalizedUtils}>

      <div className={classes.form}>
        <div className={classes.control}>
          <DatePicker autoOk={true} label="Due Date" value={values.due_date} onChange={v => setValue('due_date', v)} format="DD/MM/yyyy"/>
        </div>

        <FormControl className={classes.control} error={errors.amount_excl !== undefined}>
          <InputLabel htmlFor="amount-field">Amount excluding GST</InputLabel>
          <Input
            id="amount-field"
            value={values.amount_excl}
            onChange={e => setValue('amount_excl', e.target.value.replace(/[^\d.]/g,''))}
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
          />
          <FormHelperText>{errors.amount_excl}</FormHelperText>
        </FormControl>

        <FormControl className={classes.control} fullWidth error={errors.description !== undefined}>
          <InputLabel htmlFor="description-field">Description</InputLabel>
          <Input
            id="description-field"
            value={values.description}
            onChange={e => setValue('description', e.target.value)}
          />
          <FormHelperText>{errors.description}</FormHelperText>
        </FormControl>

        <FormControl className={classes.control} fullWidth>
          <FormControlLabel
            control={<Switch checked={values.repeats} onChange={e => setValue('repeats', e.target.checked)}/>}
            label="Repeating Payment"
          />
        </FormControl>

        <Fade in={values.repeats}>
          <FormControl className={classes.control} fullWidth error={errors.repeat_count !== undefined}>
            <InputLabel htmlFor="repeat-count-field">Total number of monthly charges</InputLabel>
            <Input
              id="repeat-count-field"
              value={values.repeat_count}
              onChange={e => setValue('repeat_count', e.target.value.replace(/[^\d]/g,''))}
            />
            <FormHelperText>{errors.repeat_count}</FormHelperText>
          </FormControl>
        </Fade>

      </div>
    </MuiPickersUtilsProvider>
  );
};

MatchingFeesForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MatchingFeesForm;
